
document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.includes("/collections/")) return;

  const target = document.querySelector("#browsehere");
  if (!target) return;

  const headerOffset = 60; // adjust for your header height
  const elementPosition = target.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
});